import { c as _c } from "react/compiler-runtime";
import { createFieldErrorHandler } from '@onefootprint/core';
import type { FieldError } from '@onefootprint/hooks';
import type { VaultData } from '@onefootprint/request-types';
import { Divider, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DeclarationsSection } from './components/declarations-section';
import { EmploymentSection } from './components/employment-section';
import { FundingSourcesSection } from './components/funding-sources-section';
import { IncomeSection } from './components/income-section';
import { InvestmentGoalsSection } from './components/investment-goals-section';
import { NetWorthSection } from './components/net-worth-section';
import { RiskToleranceSection } from './components/risk-tolerance-section';
import type { InvestorProfileFormData } from './types';
import { fromVaultData, toVaultData } from './utils/format-vault-data';
type CollectInvestorProfileProps = {
  decryptedData?: VaultData;
  isLoading: boolean;
  onSubmit: (data: VaultData, onError: (errors: FieldError[]) => void, files?: File[]) => void;
};
export const CollectInvestorProfile = t0 => {
  const $ = _c(31);
  const {
    decryptedData,
    isLoading,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectInvestorProfile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== decryptedData) {
    t2 = fromVaultData(decryptedData);
    $[1] = decryptedData;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      defaultValues: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const methods = useForm(t3);
  let T0;
  let t4;
  let t5;
  if ($[5] !== methods || $[6] !== onSubmit) {
    const handleFieldErrors = createFieldErrorHandler(methods);
    const handleFormSubmit = data => {
      const vaultData = toVaultData(data);
      const files = data.declarationFiles?.length > 0 ? data.declarationFiles : undefined;
      onSubmit(vaultData, handleFieldErrors, files);
    };
    T0 = FormProvider;
    t5 = methods;
    t4 = methods.handleSubmit(handleFormSubmit);
    $[5] = methods;
    $[6] = onSubmit;
    $[7] = T0;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp2);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp3);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = {
      text: t8,
      type: "submit"
    };
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col gap-8"><EmploymentSection /><Divider /><IncomeSection /><Divider /><NetWorthSection /><Divider /><FundingSourcesSection /><Divider /><InvestmentGoalsSection /><Divider /><RiskToleranceSection /><Divider /><DeclarationsSection /></div>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isLoading || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t11 = <PageShell title={t6} subtitle={t7} cta={t9} isLoading={isLoading}>{t10}</PageShell>;
    $[19] = isLoading;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t4) {
    t12 = <form onSubmit={t4}>{t11}</form>;
    $[24] = t11;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== T0 || $[28] !== t12 || $[29] !== t5) {
    t13 = <T0 {...t5}>{t12}</T0>;
    $[27] = T0;
    $[28] = t12;
    $[29] = t5;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
export default CollectInvestorProfile;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.cta;
}